import { DESKTOP_MIN_WIDTH } from 'constants';
import useLang from 'hooks/useLang';
import Form from 'react-bootstrap/Form';
import styled from 'styled-components';
import ButtonCommon from '../common/ButtonCommon';
import FormResetPasswordExpired from './components/FormResetPasswordExpired';
import FormResetPasswordSuccess from './components/FormResetPasswordSuccess';

const FormResetPassword = ({
  isResetPasswordSuccess,
  isResetPasswordExpired,
  handleSubmit,
  renderPasswordRequires,
  renderFormInputValidations,
}) => {
  const { t } = useLang();

  if (isResetPasswordExpired) {
    return <FormResetPasswordExpired />;
  }
  if (isResetPasswordSuccess) {
    return <FormResetPasswordSuccess />;
  }
  return (
    <FormResetPasswordWrap>
      <TitleH3>{t('reset_password_text_reset_password')}</TitleH3>
      <Paragraph>{t('reset_password_text_password_requirements')}</Paragraph>
      {renderPasswordRequires()}
      <FormResetPasswordStyled>
        {renderFormInputValidations()}
        <ConfirmSubmit>
          <ButtonCommon
            value={t('button_confirm')}
            color="var(--c-primary)"
            background="var(--bg-primary)"
            styles={{
              margin: '0px',
              width: '200px',
            }}
            onClick={handleSubmit}
            isUseKeyDown
            isFill={true}
          />
        </ConfirmSubmit>
      </FormResetPasswordStyled>
    </FormResetPasswordWrap>
  );
};

const FormResetPasswordWrap = styled.div`
  padding: 40px;
  background: var(--ds-c-white);
  box-shadow: 0px 4px 15px rgb(0 0 0 / 12%);
  border-radius: 40px;

  @media screen and (min-width: 1280px) {
    width: 437px;
    height: fit-content;
  }

  @media screen and (min-width: 1440px) {
    width: 517px;
    height: fit-content;
  }
`;

const FormResetPasswordStyled = styled(Form)`
  position: relative;
  width: 100%;
  height: calc(100% - 96px);
`;

const ConfirmSubmit = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
`;

const TitleH3 = styled.h3`
  font-family: var(--ff-primary);
  font-style: normal;
  font-weight: 800;
  font-size: 24px;
  line-height: 29px;

  color: var(--ds-c-grey-dark);
  margin-bottom: 8px;
`;

const Paragraph = styled.p`
  font-family: var(--ff-primary);
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;

  color: var(--ds-c-grey-dark);
  margin-bottom: 8px;

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    font-size: 16px;
    line-height: 20px;
  }
`;

export default FormResetPassword;
